import loadSessionModule from './modules/Session.module';
const loadRentalModule = () => ({
    hasRouter: false,
    modules: [loadSessionModule()],
});
export default loadRentalModule;
